import { NavItemService } from '@/services/api/nav-item.service';
import { PermsService } from '@/services/api/perms.service';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppNav, NavCategory } from 'src/app/models/app-nav';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { RoleItemsComponent } from './role-editor/role-items.component';
import { AppNavComponent } from './navigation-editor/nav-items.component';
import { ApiPermissionsComponent } from './perms-editor/perms-items.component';

@Component({
  selector: 'app-app-perms',
  imports: [TabsModule, CommonModule, RoleItemsComponent, AppNavComponent, ApiPermissionsComponent],
  template: `
  <div class="card shadow-2 border-round p-4">
    <p-tabs>
    <p-tablist>
        <p-tab value="0">Roles</p-tab>
        <p-tab value="1">Navigation</p-tab>
        <p-tab value="2">Permissions</p-tab>
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel value="0">
        <app-role-items></app-role-items>
        </p-tabpanel>
        <p-tabpanel value="1">
        <app-app-nav [navItems]="navItemService.navItems()" (refreshNav)="collectNavItems()"></app-app-nav>
        </p-tabpanel>
        <p-tabpanel value="2">   
        <app-api-permissions></app-api-permissions>
        </p-tabpanel>
    </p-tabpanels>
    </p-tabs>
</div>
  `,
  styles: `
  
  `
})
export class AppPermsComponent {
  activeIndex: number = 0;

  constructor(
    private permsService: PermsService,
    public navItemService: NavItemService,
  ) { }

  getSelectedCategory(nav:AppNav) {
    return this.navItemService.getSelectedCategory(nav);
  }

  collectNavItems() {
    return this.navItemService.collectNavItems();
  }

}
